var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"noReturnShopHeadHome"}},[_c('vHeader'),_vm._v(" "),_c('noReturnShopHead'),_vm._v(" "),_c('div',{staticClass:"contain"},[_c('router-view')],1),_vm._v(" "),_c('footerCopy')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c182d584","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/noReturnShopHeadHome.vue
// module id = null
// module chunks = 